import React from "react";

import { Helmet } from "react-helmet-async";

const GoogleReviews = ({elfsight_id}) => (
    <React.Fragment>
        <div class={elfsight_id} data-elfsight-app-lazy></div>
        <Helmet>
            <script src="https://static.elfsight.com/platform/platform.js" data-use-service-core defer></script>
        </Helmet>
    </React.Fragment>
);

export default GoogleReviews;



// WEBPACK FOOTER //
// ./components/misc/GoogleReviews.jsx